import { FilterBuilder } from './odataFilterBuilder';
import { makeSkipParam } from '../helpers/formatters';
import { OdataParams } from '../types/odataParams';

enum FragmentType {
  OrderBy = '$orderBy',
  Top = '$top',
  Skip = '$skip',
  Expand = '$expand',
  Select = '$select'
}

type QueryFragment = {
  type: FragmentType;
  value: string | number;
};

const { Expand, OrderBy, Select, Skip, Top } = FragmentType;

export class QueryBuilder {
  private fragments: QueryFragment[] = [];
  private filterQuery: string = '';

  orderBy = (orderBy: string | string[] | undefined) => {
    if (orderBy && typeof orderBy === 'string') {
      this.fragments.push({ type: OrderBy, value: orderBy });
    }

    return this;
  };

  top = (top: number | string) => {
    this.fragments.push({ type: Top, value: top.toString() });

    return this;
  };

  skip = (amount: number | string) => {
    this.fragments.push({ type: Skip, value: amount.toString() });

    return this;
  };

  skipByPage = (page: string | string[] | undefined, top: number | string) => {
    const skip = makeSkipParam(page, Number(top));

    if (skip !== undefined) {
      this.fragments.push({ type: Skip, value: skip.toString() });
    }

    return this;
  };

  expand = (fields: string | string[]) => {
    this.fragments.push({ type: Expand, value: Array.isArray(fields) ? fields.join(',') : fields });

    return this;
  };

  filter = (predicate: (filter: FilterBuilder) => FilterBuilder) => {
    this.filterQuery = predicate(new FilterBuilder()).toQueryString();

    return this;
  };

  select = (fields: string | string[]) => {
    this.fragments.push({ type: Select, value: Array.isArray(fields) ? fields.join(',') : fields });

    return this;
  };

  toQueryParam = (): OdataParams => {
    let queryParamObject: OdataParams = {};

    if (this.fragments.length < 1 && !this.filterQuery) {
      return queryParamObject;
    }

    queryParamObject = this.fragments.reduce(
      (outputObject, fragment) => ({ ...outputObject, [fragment.type]: fragment.value }),
      {}
    );

    if (this.filterQuery) {
      queryParamObject = {
        ...queryParamObject,
        $filter: this.filterQuery
      };
    }

    return queryParamObject;
  };
}
